export default 'fonts/637e0a99e6df9b3f422e5b3a04da2a41.eot';